module.exports = __webpack_public_path__ + "assets/paypal.4b24d062.png";